import { useEffect } from 'react'
import {getListDeductions} from '../../../services/sPay/deduction.service'


const useGetDeductionsMaintainer = (mantainerList, setMantainer) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListDeductions();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({id: element.id , name: element.name, order: element.order})
                });

                setMantainer(aux_array);
            }
            catch (error) {
                setMantainer([])
            }
        }
        
        if (mantainerList === null) {
            getData()
        }
    }, [mantainerList, setMantainer]);
}

export {
    useGetDeductionsMaintainer
}